export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAAAAACo4kLRAAAAGElEQVR42mN4Cgef4IBhSAsimAjpIS0IAOy3cAhwjzZfAAAAAElFTkSuQmCC"